import { Square } from './Square';

const Skeleton = {
  Square,
};

export default Skeleton;
